import React from 'react';
import PropTypes, { object } from 'prop-types';
import { PieChart, Pie, Cell, Tooltip } from 'recharts';

import CustomTooltip from './CustomTooltip/CustomTooltip';
import { Text } from 'components/common/Elements/Elements';

import { colorsNew } from 'components/common/charts/helpers/config';

import classes from './DonutNewT.module.scss';

const DonutNewT = ({ data = [], centerText }) => {
  if (data.length === 0) {
    const empty = [{ name: '', percent: 100 }];
    return (
      <div className={classes.box}>
        <Text className={classes.count} type="p">
          0
        </Text>
        <PieChart width={123} height={123}>
          <Pie
            data={empty}
            innerRadius={45}
            outerRadius={61}
            dataKey="percent"
            blendStroke
          >
            <Cell fill="#dde6f2" />
          </Pie>
        </PieChart>
      </div>
    );
  }

  return (
    <div className={classes.box}>
      <Text className={classes.count} type="p">
        {centerText}
      </Text>
      <PieChart width={180} height={123} className={classes.chart}>
        <Pie
          data={data}
          innerRadius={45}
          outerRadius={61}
          dataKey="score"
          blendStroke
        >
          {data.map((entry, index) => (
            <Cell
              key={`${entry.name}-${index}`}
              fill={entry.color ? entry.color : colorsNew[index]}
            />
          ))}
        </Pie>
        <Tooltip content={<CustomTooltip />} />
      </PieChart>
    </div>
  );
};

DonutNewT.propTypes = {
  data: PropTypes.arrayOf(object),
  centerText: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default DonutNewT;
